import type { I18n } from '@lingui/core';

import { getCatInAFlatFAQConfig } from '@rover/pages/src/account/BrandActivation/components/frequently-asked-questions/constants/catInAFlatFAQConfig';
import { FAQConfig } from '@rover/pages/src/account/BrandActivation/components/frequently-asked-questions/types';
import type { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest/model/countryConfiguration';
import { RoverBrand } from '@rover/types/src/RoverBrand';

export interface BrandWelcomePageConfig {
  displayName: string;
  helpCenterUrl: string;
  faqConfig: FAQConfig | null;
}

export const getBrandWelcomePageConfig = (
  brand: RoverBrand,
  i18n: I18n,
  countryConfig?: CountryConfiguration | null
): BrandWelcomePageConfig => {
  const configs: Record<RoverBrand, BrandWelcomePageConfig> = {
    [RoverBrand.CatInAFlat]: {
      displayName: 'Cat in a Flat',
      helpCenterUrl: 'https://catinaflat.zendesk.com/hc/',
      faqConfig: getCatInAFlatFAQConfig({ i18n, countryConfig }),
    },
    [RoverBrand.DogBuddy]: {
      displayName: 'DogBuddy',
      helpCenterUrl: countryConfig?.urls.supportUrl || 'https://support.rover.com/hc/',
      faqConfig: null,
    },
    [RoverBrand.Rover]: {
      displayName: 'Rover',
      helpCenterUrl: countryConfig?.urls.supportUrl || 'https://support.rover.com/hc/',
      faqConfig: getCatInAFlatFAQConfig({ i18n, countryConfig, showSitter101: true }),
    },
    [RoverBrand.MadPaws]: {
      displayName: 'Mad Paws',
      helpCenterUrl: countryConfig?.urls.supportUrl || 'https://support.rover.com/hc/',
      faqConfig: null,
    },
  };

  return configs[brand] ?? null;
};
